<div [ngSwitch]="data.type">
  <div *ngSwitchCase="'Add'"><h2 mat-dialog-title class="text-center">{{ "addArea" | translate }}</h2></div>
  <div *ngSwitchCase="'Edit'"><h2 mat-dialog-title class="text-center">{{ "editArea" | translate }}</h2></div>
</div>
<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" floatLabel="always" class="form-group">
      <mat-label>{{ "area" | translate }}</mat-label>
      <input matInput class="form-control" required formControlName="prdAreaNameEn" autocomplete="off" (keyup)="onValidateAreaName($event)">
    </mat-form-field>
    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>{{ "cancel" | translate }}</button>
      <button mat-button color="primary" mat-dialog-close [disabled]="!form.valid" type="submit">
        <span *ngIf="data.type == 'Add'; else editBlock"> {{ "add" | translate }}</span>
        <ng-template #editBlock>{{ "save" | translate }}</ng-template>
      </button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>